// Splits `total` across `weights`, flooring every share to `minSlot` and
// re-sharing the remainder among the rest — repeated until stable, since
// shrinking the free shares can push a previously-fine one under the minimum
// too. Keeps tiny entries legible instead of collapsing: donut arc lengths and
// treemap tile areas both lay out through it. Two properties callers rely on:
// when `minSlot * n >= total` it degrades to an equal split, and weights sorted
// descending yield a non-increasing result.
export function distributeSlots(
  weights: number[],
  total: number,
  minSlot: number
): number[] {
  const n = weights.length;
  if (n === 0) return [];
  if (minSlot * n >= total) return weights.map(() => total / n);
  const fixed = new Array<boolean>(n).fill(false);
  while (true) {
    let free = 0;
    let pinned = 0;
    for (let i = 0; i < n; i++) {
      if (fixed[i]) pinned++;
      else free += weights[i]!;
    }
    const remaining = total - pinned * minSlot;
    let changed = false;
    for (let i = 0; i < n; i++) {
      if (!fixed[i] && (remaining * weights[i]!) / free < minSlot) {
        fixed[i] = true;
        changed = true;
      }
    }
    if (!changed) {
      return weights.map((w, i) =>
        fixed[i] ? minSlot : (remaining * w) / free
      );
    }
  }
}
